export const MaterialIconNames = {
  sistemaShow: "vision",
  sistemaEdit: "create",
  addCircle: "add_circle",
  delete: "delete_outline",
  close: "close",
  filterAlt: "filter_alt",
};
